export const FETCH_LIVE_DATA_SUCCESS = "FETCH_LIVE_DATA_SUCCESS";
export const FETCH_LIVE_DATA_FAILED = "FETCH_LIVE_DATA_FAILED";
